import { Card } from 'antd'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { getDownloadTicketPDFById } from '../../services/auth/authServices';

const DownloadTicketPDF = () => {
    let location = useLocation();
    const [paymentDetails, setPaymentDetails] = useState("");
    const [loader, setLoading] = useState(null);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const bookingId = queryParams.get('bookingId');
        setPaymentDetails({ bookingId });
    }, [location]);

    // console.log("paymentDetails", paymentDetails?.bookingId);

    const generatePdf = async () => {
        setLoading(true)
        try {
            const response = await getDownloadTicketPDFById(paymentDetails?.bookingId);
            setLoading(false)
            const file = new Blob([response], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(file);
            link.download = 'ticket.pdf';
            link.click();
            URL.revokeObjectURL(link.href);

        } catch (error) {
            setLoading(false)
            console.error('Error downloading the PDF:', error);
        }

    }

    useEffect(() => {
        if (paymentDetails?.bookingId) {
            generatePdf();
        }
    }, [paymentDetails?.bookingId]);


    return (
        <div className="payment-status">
            <Card className="payment-status-card">
                {loader ? (
                    <p>We are processing your request. Please wait while we download your ticket...</p>
                ) : (
                    <p>Your ticket has been successfully downloaded. Please check your downloads folder for the file.</p>
                )}
            </Card>
        </div>
    )
}

export default DownloadTicketPDF